import React from 'react';

export const PageWrapper = ({children, className = ''}) => {
  return (
    <div className={`page-wrapper ${className}`}>
      {children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js